import $ from 'jquery';

const FvLine = () => {
  const $IntroFvLine = $('.js-IntroFvLine');
  if (!$IntroFvLine.length) return;

  const THRESHOLD = 0;

  const checkScroll = () => {
    const y = window.scrollY || window.pageYOffset;

    if (y > THRESHOLD) {
      // クラスを付与してイベントリスナーを削除
      $IntroFvLine.addClass('is-lineStart');
      window.removeEventListener('scroll', checkScroll);
    }
  };

  // 初回実行
  const y = window.scrollY || window.pageYOffset;
  if (y > THRESHOLD) {
    $IntroFvLine.addClass('is-lineStartDelay');
  } else {
    // 最上部にいる場合はスクロールを監視
    window.addEventListener('scroll', checkScroll, { passive: true });
  }
};

export default FvLine;